import React, { ReactNode } from 'react';
import clsx from 'clsx';
import Icons from '@/const/icons';
import { Icon, Typography } from '@/components/common';
import { TooltipComponent } from '@/components/common/tooltip';

interface Props {
	title: string;
	tooltip?: string | ReactNode;
	className?: string;
	children: ReactNode;
}

export const ContainerImage: React.FC<Props> = ({
	title,
	tooltip,
	className,
	children,
}) => {
	return (
		<div
			className={clsx(
				'border border-gray-disabled rounded-[32px] p-5 h-[284px] space-y-2',
				className
			)}
		>
			<div className="flex items-center gap-2">
				<Typography type="regular-16">{title}</Typography>
				{tooltip && (
					<TooltipComponent
						className="!w-[310px]"
						classNameLabel="!text-left"
						label={tooltip}
						trigger={
							<div>
								<Icon src={Icons.infoCircle} className="!size-6" />
							</div>
						}
					/>
				)}
			</div>
			{children}
		</div>
	);
};
